import { z } from 'zod';
import { boundedText, maxCodePoints } from '@/lib/forms/primitives';

/**
 * Verification unit (add / edit).
 *
 * A module-level const, not a `createSchema(t)` factory: messages resolve
 * when issues are materialized, so this stays stable across language changes.
 *
 * CAPS ARE DB MIRRORS, not product choices —
 *   database/migrations/019_verification_tables.sql:20  unit_number VARCHAR(20)
 *   database/migrations/019_verification_tables.sql:21  unit_name   VARCHAR(200)
 * `AddUnitRequest` types both as bare `str` with no length, so today an
 * over-long value reaches asyncpg and returns a 500 rather than a 400. Enforcing
 * the cap here turns that into visible field feedback.
 *
 * `unitNumber` is deliberately NOT required. The DB column is NOT NULL but an
 * empty string satisfies it, and the shipped dialog gates the save on unit NAME
 * alone — so blank unit numbers post today and must keep posting.
 */
export const unitSchema = z.object({
  unitNumber: z
    .string()
    .trim()
    .check(maxCodePoints(20, 'validation.maxLength')),
  unitName: boundedText(200, 'validation.required', 'validation.maxLength'),
});

export type UnitFormValues = z.infer<typeof unitSchema>;
